<template>
    <div
        class="inline-flex items-center justify-start gap-2 bg-gradient-to-br from-white/20 to-white/5 px-4 py-3 outline outline-1 outline-offset-[-1px] outline-white/25 backdrop-blur-sm"
    >
        <div
            class="text-md flex items-center justify-between gap-3 text-left leading-none font-bold tracking-tight text-white"
        >
            <slot></slot>
        </div>
    </div>
</template>

<style>
.button-transparent {
}
</style>
